import type { TimelineActivity } from '../Timeline'

function scrollToId(id: string, smooth?: boolean) {
  document.querySelector(`#${id}`)?.scrollIntoView({
    behavior: smooth ? 'smooth' : 'auto',
    block: 'start',
    inline: 'nearest',
  })
}

function scrollToToday(smooth?: boolean) {
  scrollToId('timelineTodayAnchor', smooth)
}

function calculateStartAnimationIndex(activities: TimelineActivity[]) {
  // Calculate at which index needs to start animating
  // We start scrolled to today, so we can't animate the entire list due to big delays at the bottom
  // With this index, we can determine which elements are off-screen and which need to animate (first visible on screen)
  let startAnimateIndex = 0

  const firstFutureActivityIndex = activities.findIndex((x) => {
    // Find the first activity that is shown on today
    return !x.hasExpired && !x.completed
  })

  startAnimateIndex =
    firstFutureActivityIndex === -1 ? activities.length - 6 : Math.min(firstFutureActivityIndex, activities.length - 6)

  return startAnimateIndex
}

export { calculateStartAnimationIndex, scrollToId, scrollToToday }
